import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import InvestmentsPage from "@/pages/InvestmentsPage";
import ForexPage from "@/pages/ForexPage";
import GoldPage from "@/pages/GoldPage";
import TravelPage from "@/pages/TravelPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import DownloadPage from "@/pages/DownloadPage";
import NotFoundPage from "@/pages/NotFoundPage";

import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/components/admin/AdminLayout";
import ProtectedAdminRoute from "@/components/admin/ProtectedAdminRoute";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminDownloads from "@/pages/admin/AdminDownloads";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAPK from "@/pages/admin/AdminAPK";

import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
        <Routes>
          {/* Public site */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/investments" element={<InvestmentsPage />} />
            <Route path="/forex" element={<ForexPage />} />
            <Route path="/gold" element={<GoldPage />} />
            <Route path="/travel" element={<TravelPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/download" element={<DownloadPage />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="faqs" element={<AdminFaqs />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="downloads" element={<AdminDownloads />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="apk" element={<AdminAPK />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0B1221",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
